/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Interaccountingemail12Inputs */

const en__field_interaccountingemail12 = /** @type {(inputs: _Field_Interaccountingemail12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`internal accounting e-mail 1`)
};

const de__field_interaccountingemail12 = /** @type {(inputs: _Field_Interaccountingemail12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interne Accounting E-Mail 1`)
};

/**
* | output |
* | --- |
* | "internal accounting e-mail 1" |
*
* @param {_Field_Interaccountingemail12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_interaccountingemail12 = /** @type {((inputs?: _Field_Interaccountingemail12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Interaccountingemail12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_interaccountingemail12(inputs)
	return de__field_interaccountingemail12(inputs)
});
export { _field_interaccountingemail12 as "_field_interAccountingEmail1" }